'use client';

import { type ReactNode } from 'react';
import { CardRummyItem } from '@/features/home/services/home';
import GameCardWithTracking from '@/features/home/components/game-card-with-tracking';
interface RummyCardWithExposureProps {
  item: CardRummyItem;
  index: number;
  currentPage?: string;
  currentModule?: string;
  children: (props: { cardRef: React.RefObject<HTMLDivElement | null>; handleClick: () => void; }) => ReactNode;
}

const CURRENT_PAGE = 'Home';
const CURRENT_MODULE = 'rummy';

export default function RummyCardWithExposure({
  item,
  index,
  currentPage = CURRENT_PAGE,
  currentModule = CURRENT_MODULE,
  children,
}: RummyCardWithExposureProps) {

  return (
    <GameCardWithTracking
      item={item}
      index={index}
      currentPage={currentPage}
      currentModule={currentModule}
      throttleWait={40 * 1000}
      getThrottleKey={(item) => `home_rummy_${item?.game_id}`}
    >
      {({ cardRef, handleClick }) => children({ cardRef, handleClick })}
    </GameCardWithTracking>
  );
}

